import { useCandidateNpsAggregate, useCandidateNpsMonthly, useActiveSurvey } from '@/lib/api/hooks';
import { NpsGauge } from '@/components/candidate/NpsGauge';
import { NpsTrendChart } from '@/components/candidate/NpsTrendChart';

interface NpsDashboardCardProps {
  candidateId: string;
  onViewDetails?: () => void;
}

export function NpsDashboardCard({ candidateId, onViewDetails }: NpsDashboardCardProps) {
  const { data: aggregateEnvelope, isLoading: aggregateLoading } = useCandidateNpsAggregate(candidateId);
  const { data: surveyEnvelope } = useActiveSurvey('candidateprofile');
  const surveyId = surveyEnvelope?.data?._id ?? '';
  const { data: monthlyEnvelope } = useCandidateNpsMonthly(surveyId);

  const aggregate = aggregateEnvelope?.data;
  const monthly = monthlyEnvelope?.data ?? [];

  if (aggregateLoading) {
    return (
      <div style={{
        padding: '16px', borderRadius: 12,
        background: 'var(--bp-surface-raised, #1a2332)',
        border: '1px solid rgba(255,255,255,0.06)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '0.8rem', color: 'var(--bp-text-muted, #64748b)' }}>Loading NPS data…</div>
      </div>
    );
  }

  if (!aggregate || aggregate.total === 0) {
    return (
      <div style={{
        padding: '16px', borderRadius: 12,
        background: 'var(--bp-surface-raised, #1a2332)',
        border: '1px solid rgba(255,255,255,0.06)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '0.85rem', fontWeight: 600, marginBottom: 4 }}>NPS Score</div>
        <div style={{ fontSize: '0.8rem', color: 'var(--bp-text-muted, #64748b)' }}>
          No ratings yet. Share your profile to get feedback.
        </div>
      </div>
    );
  }

  return (
    <div style={{
      padding: '16px', borderRadius: 12,
      background: 'var(--bp-surface-raised, #1a2332)',
      border: '1px solid rgba(255,255,255,0.06)',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 600 }}>NPS Score</h3>
        {onViewDetails && (
          <button
            type="button" onClick={onViewDetails}
            style={{
              fontSize: '0.75rem', color: 'var(--bp-blue-400, #60a5fa)',
              background: 'none', border: 'none', cursor: 'pointer',
            }}
          >
            View details →
          </button>
        )}
      </div>

      <NpsGauge aggregate={aggregate} />

      {monthly.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <div style={{ fontSize: '0.8rem', fontWeight: 500, marginBottom: 8 }}>Trend</div>
          <NpsTrendChart data={monthly} />
        </div>
      )}
    </div>
  );
}
